import { t } from 'i18next';

export type RouteKey =
  | 'about'
  | 'absences'
  | 'accounts'
  | 'add'
  | 'admin'
  | 'adminInstitution'
  | 'appointments'
  | 'assignments'
  | 'classbook'
  | 'collaborationCourses'
  | 'collaborationGroups'
  | 'collaborations'
  | 'courses'
  | 'create'
  | 'edit'
  | 'evaluation'
  | 'groups'
  | 'institution'
  | 'institutionClasses'
  | 'institutionCourses'
  | 'institutionGroups'
  | 'institutionPersons'
  | 'institutionSchoolyears'
  | 'institutionSubjects'
  | 'lessons'
  | 'login'
  | 'materialArchive'
  | 'mediaLibrary'
  | 'meetings'
  | 'meetingsBBB'
  | 'meetingsZoom'
  | 'messages'
  | 'organizations'
  | 'persons'
  | 'procurat'
  | 'profile'
  | 'public'
  | 'root'
  | 'submissions'
  | 'templates'
  | 'workmaterials';

export const routeTitles: Record<RouteKey, string> = {
  about: t('common.about'),
  absences: t('absences.title_other'),
  accounts: 'Accounts',
  add: t('common.add'),
  admin: t('admin.title'),
  adminInstitution: t('institution.admin'),
  appointments: t('appointments.title'),
  assignments: t('assignments.title', { count: 2 }),
  classbook: t('classbook.title', { count: 1 }),
  collaborationCourses: t('courses.title'),
  collaborationGroups: t('groups.title'),
  collaborations: t('collaborations.title'),
  courses: t('courses.title'),
  create: t('common.create'),
  edit: t('common.edit'),
  evaluation: t('absences.evaluation.title', { count: 1 }),
  groups: t('groups.title'),
  institution: t('institution.myInstitution'),
  institutionClasses: t('classes.titlePlural'),
  institutionCourses: t('courses.title'),
  institutionGroups: t('groups.title'),
  institutionPersons: t('persons.title', { count: 2 }),
  institutionSchoolyears: t('schoolyears.title'),
  institutionSubjects: t('subjects.title', { count: 2 }),
  lessons: t('lessons.title'),
  login: t('routes.login.title'),
  materialArchive: 'Material Archive',
  mediaLibrary: 'Medien',
  meetings: t('meetings.title'),
  meetingsBBB: t('meetings.runningBBB'),
  meetingsZoom: t('meetings.runningZoom'),
  messages: t('messages.title', { count: 2 }),
  organizations: t('organizations.title', { count: 2 }),
  persons: t('persons.title', { count: 2 }),
  procurat: t('procuratImport.title'),
  profile: t('profiles.titleSingular'),
  public: '',
  root: 'Dashboard',
  submissions: t('submissions.title', { count: 1 }),
  templates: t('templates.title'),
  workmaterials: t('workmaterials.title'),
};
